import { IOrganization } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { useDialogs } from "@toolpad/core";
import { EditOrganizationDialog } from "../dialogs/organization/EditOrganizationDialog";

interface IProps {
    /**
     * the organization to edit
     */
    organization: IOrganization;
}

/**
 * a button to edit an organization
 */
export const EditOrganizationButton = ({ organization }: IProps) => {
    const dialogs = useDialogs();

    const handleClick = () => {
        dialogs.open(EditOrganizationDialog, {
            organization,
            users: [],
        });
    };

    return (
        <Button
            variant="contained"
            color="secondary"
            sx={{ borderRadius: 29 }}
            disableElevation
            onClick={handleClick}
        >
            Edit
        </Button>
    );
};
